export const StatisticsSection = () => {
  return (
    <section id="statistics" className="relative py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <h2 className="mb-12 text-center text-3xl font-bold">Why choose our Resume Builder?</h2>
        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-2">
          {[
            {
              icon: "📄",
              title: "Professional Templates",
              description: "Choose from dozens of ATS-friendly templates designed by HR experts",
            },
            {
              icon: "⚡",
              title: "AI-Powered Suggestions",
              description: "Get smart content suggestions to highlight your achievements",
            },
            {
              icon: "🏆",
              title: "Industry-Specific",
              description: "Templates and content tailored to your specific industry",
            },
            {
              icon: "⏱️",
              title: "Quick and Easy",
              description: "Create a professional resume in less than 15 minutes",
            },
          ].map((feature, index) => (
            <div key={index} className="rounded-lg border p-6 transition hover:shadow-lg">
              <div className="mb-4 text-3xl">{feature.icon}</div>
              <h3 className="mb-2 text-xl font-semibold">{feature.title}</h3>
              <p className="">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
